import styled from 'styled-components';


const FooterNavigationItem = styled.li`
    list-style-type: none;
    white-space: nowrap;
`;

export default FooterNavigationItem;
